export const TeamData = [
    
    {
      "Name": "Jaison Manjaly",
      "Designation": "Head of Sports",
      "Image": require("../assets/team/Jaison Manjaly.jpg")
    },
    {
      "Name": "Tanya Srivastava",
      "Designation": "Sports Faculty Advisor",
      "Image": require("../assets/team/Tanya Srivastava.jpg")
    },
    {
      "Name": "Dinesh Parmar",
      "Designation": "Sr. PTI",
      "Image": require("../assets/team/Dinesh Parmar.jpg")
    },
    {
      "Name": "Vinay Vasava",
      "Designation": "Sports Facility Manager",
      "Image": require("../assets/team/Vinay Vasava.jpg")
    },
    {
      "Name": "Vedangraj Vala",
      "Designation": "Sports Management Coordinator",
      "Image": require("../assets/team/Vedangraj Vala.jpg")
    },
    {
      "Name": "Harsh Mehta",
      "Designation": "Sports Management Trainee",
      "Image": require("../assets/team/Harsh Mehta.jpg")
    },
    {
      "Name": "Santosh Kumar Joshi",
      "Designation": "Assistant PTI",
      "Image": require("../assets/team/Santosh Kumar Joshi.jpg")
    },
    {
      "Name": "Tulsa Pujhari",
      "Designation": "Yoga Instructor",
      "Image": require("../assets/team/Tulsa Pujhari.jpg")
    },
    {
      "Name": "Makwana Bharti",
      "Designation": "Sports Assistant",
      "Image": require("../assets/team/Makwana Bharti.jpg")
    },
    {
      "Name": "Payal Vaniya",
      "Designation": "Sports Management Trainee",
      "Image": require("../assets/team/Payal Vaniya.jpg")
    },
    {
      "Name": "Ratnesh Singh",
      "Designation": "Assistant PTI",
      "Image": require("../assets/team/Ratnesh Singh.jpg")
    }
   
]